import { Injectable, inject } from '@angular/core';
import { FullStory, init, isInitialized } from '@fullstory/browser';
import * as Sentry from '@sentry/browser';
import { Environment } from '../environment/environment';

@Injectable({ providedIn: 'root' })
export class FullstoryService {
  private readonly environment = inject(Environment);

  init(): void {
    init({ orgId: '9ZEQS', devMode: !this.environment.production });
    this.linkSentryEvents();
  }

  identify(uid: string, properties: { displayName: string; email: string; companyIdentifier: string }): void {
    if (!isInitialized()) {
      return;
    }
    FullStory('setIdentity', { uid, properties });
  }

  private linkSentryEvents(): void {
    Sentry.addEventProcessor((event, hint) => {
      const error = hint.originalException;
      if (typeof error === 'string') {
        FullStory('trackEvent', { name: 'Application Error', properties: { message: error, sentryEventId: hint.event_id } });
      } else if (error instanceof Error) {
        FullStory('trackEvent', {
          name: 'Application Error',
          properties: { name: error.name, message: error.message, stack: error.stack, sentryEventId: hint.event_id },
        });
      }
      return { ...event, extra: { ...event.extra, fullstory: FullStory('getSession', { format: 'url.now' }) ?? 'session URL not ready' } };
    });
  }
}
